import { BadgeProps } from "@oysterhr/ui"

import { BenefitsEnrollment, BenefitsEnrollmentStateEnum } from "@oysterhr/schema"
import { useTranslation } from "react-i18next"
import { BadgeDropdown } from "~/shared/components/BadgeDropdown"
export interface EnrollmentStatePillProps {
  state: BenefitsEnrollmentStateEnum
  startDate?: BenefitsEnrollment["startDate"]
  values?: {
    title: string
    onClick: () => void
  }[]
}

export const EnrollmentStatePillColors: Record<
  BenefitsEnrollmentStateEnum | "AppliedWithoutStartDate" | string,
  BadgeProps["variation"]
> = {
  AppliedWithoutStartDate: "warning",
  [BenefitsEnrollmentStateEnum.Applied]: "warning",
  [BenefitsEnrollmentStateEnum.InProgress]: "warning",
  [BenefitsEnrollmentStateEnum.Enrolled]: "success",
  [BenefitsEnrollmentStateEnum.Denied]: "error",
  [BenefitsEnrollmentStateEnum.OptedOut]: "gray",
  [BenefitsEnrollmentStateEnum.Cancelled]: "gray",
  [BenefitsEnrollmentStateEnum.ModifiedEnrollment]: "gray",
  [BenefitsEnrollmentStateEnum.Finished]: "gray",
  [BenefitsEnrollmentStateEnum.AwaitingToBeFinished]: "warning",
  [BenefitsEnrollmentStateEnum.Provisioned]: "success",
}

export function useEnrollmentState(
  enrollment: Pick<BenefitsEnrollment, "state" | "startDate"> | null | undefined,
) {
  const { state, startDate } = enrollment || {}

  if (state === BenefitsEnrollmentStateEnum.Applied && !startDate) {
    return "AppliedWithoutStartDate"
  }
  return state
}

export function EnrollmentStatePill({ state, startDate, ...otherProps }: EnrollmentStatePillProps) {
  const { t } = useTranslation("benefits/EnrollmentState")
  const displayedState = useEnrollmentState({
    state,
    startDate,
  })

  return (
    <BadgeDropdown
      {...otherProps}
      variation={EnrollmentStatePillColors[displayedState || BenefitsEnrollmentStateEnum.Denied]}
      size="sm"
    >
      {t(`states.${displayedState}`)}
    </BadgeDropdown>
  )
}
